import SideNav from "../SideNav/SideNav";
import Fancybox from "../Fancybox/Fancybox";
import '@fancyapps/ui/dist/fancybox/fancybox.css';

import { Image } from "react-bootstrap";

import screenshot1 from '../../assets/img/screenshots/menu_system/1.jpg';
import screenshot2 from '../../assets/img/screenshots/menu_system/2.jpg';
import screenshot3 from '../../assets/img/screenshots/menu_system/3.jpg';
import screenshot4 from '../../assets/img/screenshots/menu_system/4.jpg';
import screenshot5 from '../../assets/img/screenshots/menu_system/5.jpg';

function Menu() {

    return (
<div id="wrap-body">
            <div class="heading-group page-name color-w">
                <h1>Menu System</h1>
                <div class="intro">
                    <p>This system includes regional sets of seasonal menus that are designed and updated every six months. There is an automated diet/menu spreading feature that allows the user to customize menus in-house to meet preferences and automatically spread food items to adjust for the different diet orders. The menus can also be easily customized with the preferred diet orders. These changes integrate with all menu sets and/or the Select Menu tray tickets to assure accuracy. The Menu System also includes extensive recipe files, menu production sheets, and nutritional analysis. Through a food distributor interface, OptimaSolutions&trade; converts our production sheet in to a suggested food order guide complete with item numbers, costs, quantity, etc. based on facility census and additional meals.</p>
                </div>
                <div class="star-group">
                    <i class="fa fa-star-o"></i>
                    <i class="fa fa-star-o star-1x"></i>
                    <i class="fa fa-star-o"></i>
                </div>
            </div>
            <div class="container" id="main-content">
                <div class="reservation">
                    <div class="title">Menu System
                        <h3>Highlights</h3>
                    </div>
                    <div class="row">
                        <div class="col-md-8">
                            <ul class="custom_list">
                                <li>The Menu Maker function allows the user to design or customize the loaded seasonal menus. Any food selected in the drop down box will spread across and adjust for the different diet orders to meet diet specifics. Menus will print with an RD signature when changes are saved and production menus are printed.</li>
                                <li>The Diet Maker on the menu allows the user to select the preferred diets for their menu headers. Once selected, all of the foods will automatically change in the column to adjust for the selected diet order. This allows the end user to customize menus with diet orders that sync with the physician ordered diets.</li>
                                <li>The Menu Maker allows the user to select a view cost option to review food item costs, meal costs and daily menu costs. This feature assists in managing raw food budgets.</li>
                                <li>Various menu sets are available: select menus, buffet menus, kosher menus, corporate menus, liberalized diet sets, therapeutic sets, etc.</li>
                                <li>Menus print in the following formats: Regular/WAGs/Spreadsheet/Weekly, Alternate/WAGs/Spreadsheet/Weekly, Daily Menus with Regular/Alternate menu items, Wall Menus with Regular/Alternates menu items, Select Menus with Regular/Alternate/Additional items.</li>
                                <li>The automated Menu Production Report compiles Tray Ticket census and Menu Maker data to generate a production report complete with food items, recipe numbers, portion sizes, production amounts, next day preparation directives and thawing directives.</li>
                                <li>Regular/HACCP/Pureed recipes scaled, categorized and numbered to sync with the automated Menu Production Reports.</li>
                                <li>Recipe Search/Scale link options, Recipe Maker and Upload functions available.</li>
                                <li>Nutritional Analysis detailing calories, fat, carbohydrates, vitamins and minerals.</li>
                                <li>Food Distributor interface allows the user to generate integrated purchase orders from a locked down order guide that calculates amount to order, displays current food prices, item description, pack size, etc.</li>
                            </ul>
                        </div>
                        <div class="col-md-4">
                            <Fancybox
                                options={{
                                    Carousel: {
                                        infinite: false,
                                    },
                                }}
                            >
                            <a href={screenshot1} data-fancybox="screenshots" data-caption="WAG Menu Example" id="lnk_screenshots">See screenshot samples</a>
                            <div style={{display:'none'}}>
                                <a href={screenshot2} data-fancybox="screenshots" data-caption="Diet Maker Function">
                                    <Image src={screenshot2}></Image>
                                </a>
                                <a href={screenshot3} data-fancybox="screenshots" data-caption="Table Menu">
                                    <Image src={screenshot3}></Image>
                                </a>
                                <a href={screenshot4} data-fancybox="screenshots" data-caption="Wall Menu">
                                    <Image src={screenshot4}></Image>
                                </a>
                                <a href={screenshot5} data-fancybox="screenshots" data-caption="Menu Cost-at-a-Glance">
                                    <Image src={screenshot5}></Image>
                                </a>
                            </div>
                            </Fancybox>
                            <SideNav/>
                        </div>
                    </div>
                </div>
            </div>
        </div>    );


}

export default Menu;